export class CompanyInfoRegData {
  address = '';
  name = '';
  license = '';
  web_site = '';
  email: string[] = [ '' ];
  phone: string[] = [ '' ];

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./app/states/auth/models/company-info-reg-data.ts